const GET_USER_ON_SEARCH = 'GET_USER_ON_SEARCH';
const SET_USER_ON_SEARCH = 'SET_USER_ON_SEARCH';

const GET_BRANCH_ADMIN_USER_DETAILS = 'GET_BRANCH_ADMIN_USER_DETAILS';
const SET_BRANCH_ADMIN_USER_DETAILS = 'SET_BRANCH_ADMIN_USER_DETAILS';

const GET_COST_CENTER_GRID_BY_USERID = 'GET_COST_CENTER_GRID_BY_USERID';
const SET_COST_CENTER_GRID_BY_USERID = 'SET_COST_CENTER_GRID_BY_USERID';

const GET_IS_COSTCENTER_VALID_FOR_SAVE = 'GET_IS_COSTCENTER_VALID_FOR_SAVE';
const SET_IS_COSTCENTER_VALID_FOR_SAVE = 'SET_IS_COSTCENTER_VALID_FOR_SAVE';

const GET_IS_COSTCENTER_SAVED_SUCCESSFULLY = 'GET_IS_COSTCENTER_SAVED_SUCCESSFULLY';
const SET_IS_COSTCENTER_SAVED_SUCCESSFULLY = 'SET_IS_COSTCENTER_SAVED_SUCCESSFULLY';

const GET_REMOVE_COST_CENTER_FOR_USER = 'GET_REMOVE_COST_CENTER_FOR_USER';
const SET_IS_REMOVE_COST_CENTER_FOR_USER = 'SET_IS_REMOVE_COST_CENTER_FOR_USER';

const GET_COST_CENTER_BYID_AND_ROLE = 'GET_COST_CENTER_BYID_AND_ROLE';
const SET_COST_CENTER_BYID_AND_ROLE = 'SET_COST_CENTER_BYID_AND_ROLE';

export {
    GET_USER_ON_SEARCH,
    SET_USER_ON_SEARCH,
    GET_BRANCH_ADMIN_USER_DETAILS,
    SET_BRANCH_ADMIN_USER_DETAILS,
    GET_COST_CENTER_GRID_BY_USERID,
    SET_COST_CENTER_GRID_BY_USERID,
    GET_IS_COSTCENTER_VALID_FOR_SAVE,
    SET_IS_COSTCENTER_VALID_FOR_SAVE,
    GET_IS_COSTCENTER_SAVED_SUCCESSFULLY,
    SET_IS_COSTCENTER_SAVED_SUCCESSFULLY,
    GET_REMOVE_COST_CENTER_FOR_USER,
    SET_IS_REMOVE_COST_CENTER_FOR_USER,
    GET_COST_CENTER_BYID_AND_ROLE,
    SET_COST_CENTER_BYID_AND_ROLE
}